/*
    All the products belonging to the subcategories listed in the following array
    will allow the user whether to select units or a custom weight when adding the product
*/
export default ['0304', '0303', '0302', '0301', '0202', '0201']
